import React, { useEffect, useState } from "react";
import { Sparkles, RefreshCw, Route, Layers, PackagePlus, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

export default function AIAssistant() {
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(false);
  const load = async () => { setLoading(true); try { const r = await api.get("/admin/ai/ops"); setD(r.data); } catch { setD(null); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6" data-testid="admin-ai">
      <div className="flex items-center justify-between">
        <p className="text-[#5C5C5C]">AI reads today's paid orders and suggests the smartest way to shop, buy and ship.</p>
        <button onClick={load} disabled={loading} data-testid="ai-refresh" className="flex items-center gap-2 text-sm font-semibold border border-[#306D29]/30 text-[#306D29] bg-white px-4 py-2 rounded-full hover:bg-[#306D29]/5">
          {loading ? <Loader2 size={15} className="animate-spin" /> : <RefreshCw size={15} />} Refresh
        </button>
      </div>

      {!d ? <p className="text-[#5C5C5C]">Loading…</p> : (
        <>
          <div className="bg-[#0D530E] text-[#FBF5DD] rounded-2xl p-6" data-testid="ai-summary">
            <p className="text-xs uppercase tracking-[0.2em] text-[#E7E1B1]/70 mb-2 flex items-center gap-2"><Sparkles size={15} /> Ops briefing</p>
            <p className="font-display text-xl leading-snug">{d.summary || `${d.orders_to_source} order(s) need sourcing across ${Object.keys(d.stores || {}).length} store(s).`}</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="bg-white border border-black/5 rounded-2xl p-5">
              <p className="font-display text-lg text-[#0D530E] flex items-center gap-2 mb-3"><Route size={17} /> Shopping route</p>
              {(d.route || []).length === 0 ? <p className="text-sm text-[#5C5C5C]">Nothing to shop right now.</p> : (
                <ol className="space-y-2">
                  {d.route.map((s, i) => (
                    <li key={s} className="flex items-center gap-3 text-sm" data-testid={`ai-route-${i}`}>
                      <span className="w-6 h-6 rounded-full bg-[#306D29] text-white text-xs flex items-center justify-center shrink-0">{i + 1}</span>
                      <span className="font-medium text-[#0D530E]">{s}</span>
                      <span className="ml-auto text-xs text-[#5C5C5C]">{(d.stores || {})[s] || 0} items</span>
                    </li>
                  ))}
                </ol>
              )}
            </div>

            <div className="bg-white border border-black/5 rounded-2xl p-5">
              <p className="font-display text-lg text-[#0D530E] flex items-center gap-2 mb-3"><PackagePlus size={17} /> Bulk-buy opportunities</p>
              {(d.bulk_buy || []).length === 0 ? <p className="text-sm text-[#5C5C5C]">No repeated products yet.</p> : (
                <div className="space-y-2">
                  {d.bulk_buy.map((b) => (
                    <div key={b.product} className="text-sm flex justify-between gap-2" data-testid={`ai-bulk-${b.product}`}>
                      <span className="truncate text-[#0D530E]">{b.product} <span className="text-[#5C5C5C]">· {b.store}</span></span>
                      <span className="shrink-0 font-semibold text-[#306D29]">×{b.total_qty} <span className="text-xs text-[#5C5C5C]">({b.orders} orders)</span></span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="bg-white border border-black/5 rounded-2xl p-5">
              <p className="font-display text-lg text-[#0D530E] flex items-center gap-2 mb-3"><Layers size={17} /> Ship together</p>
              {(d.consolidate || []).length === 0 ? <p className="text-sm text-[#5C5C5C]">No packages ready to consolidate.</p> : (
                <div className="space-y-2">
                  {d.consolidate.map((c) => (
                    <div key={c.destination} className="text-sm" data-testid={`ai-consolidate-${c.destination}`}>
                      <p className="font-medium text-[#0D530E]">{c.destination}</p>
                      <p className="text-xs text-[#5C5C5C]">{c.packages.length} packages: {c.packages.join(", ")}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
